import Icon from 'core/assets/icons';
import { nl2br } from 'core/utils/helper';
import { _t } from "core/language";

const LoadingAI = ({text}:any) => {
  return (
    <div
      className="fixed top-0 left-0 h-screen w-screen bg-dark bg-opacity-70"
      style={{zIndex: 200}}
    >
      <div className="text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full">
        <div className="space-y-[24px]">
          <div className="w-full flex justify-center">
            <img
              src={Icon.RecipeAiLoading}
              alt="loading"
              width="72"
              height="72"
            />
          </div>
          <div
            className="w-full text-[16px]"
            dangerouslySetInnerHTML={{__html: nl2br(_t(text || 'aiChef.loading'))}}
          />
        </div>
      </div>
    </div>
  )
}

export default LoadingAI;
